module.exports = "/assets/data/9bbd18874cf9182c5d3bbdda2dce5570-UB7.data.json";